import { render, staticRenderFns } from "./UnitBasic.vue?vue&type=template&id=15a7837f&scoped=true&"
import script from "./UnitBasic.vue?vue&type=script&lang=ts&"
export * from "./UnitBasic.vue?vue&type=script&lang=ts&"
import style0 from "./UnitBasic.vue?vue&type=style&index=0&id=15a7837f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7837f",
  null
  
)

export default component.exports